var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgReportDownloadDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.251,
    height: 18.29,
    viewBox: "0 0 15.251 18.29"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-report-download-disabled_svg__cls-2{fill:none;stroke-linecap:round;stroke:#bbb;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-report-download-disabled_svg__ICN_Descarca_PDF_Enabled",
    "data-name": "ICN_Descarca PDF_Enabled",
    transform: "translate(.8 .8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-report-download-disabled_svg__Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-report-download-disabled_svg__Path_823",
    "data-name": "Path 823",
    d: "M3.695 0h6.262l3.695 3.463v9.763a3.584 3.584 0 01-3.695 3.464H3.695A3.584 3.584 0 010 13.227V3.463A3.584 3.584 0 013.695 0z",
    strokeWidth: 1.6,
    strokeLinejoin: "round",
    stroke: "#bbb",
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-report-download-disabled_svg__Path_822",
    "data-name": "Path 822",
    className: "kpmg-report-download-disabled_svg__cls-2",
    d: "M0 .6v3.434",
    transform: "translate(9.698 -.47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-report-download-disabled_svg__Line_62",
    "data-name": "Line 62",
    className: "kpmg-report-download-disabled_svg__cls-2",
    transform: "translate(9.699 3.564)",
    d: "M0 0h3.695"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-report-download-disabled_svg__Layer_1",
    "data-name": "Layer 1",
    transform: "translate(2.204 4.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-report-download-disabled_svg__Group_977",
    "data-name": "Group 977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-report-download-disabled_svg__Path_845",
    "data-name": "Path 845",
    d: "M8.88 5.441a1.842 1.842 0 00-1.189-.28 9.853 9.853 0 00-1.43.1 3.646 3.646 0 01-.664-.458 4.848 4.848 0 01-1.2-1.859l.046-.188A12.017 12.017 0 004.654.579a.635.635 0 00-.037-.156L4.592.359a.515.515 0 00-.47-.36h-.14 0A.531.531 0 003.44.34a6.293 6.293 0 00.33 2.839l-.083.2a22.39 22.39 0 01-.781 1.641l-.033.065c-.27.529-.516.979-.738 1.359l-.23.121c-.017.009-.41.217-.5.273a2.806 2.806 0 00-1.389 1.42.35.35 0 00.132.386l.222.112a.669.669 0 00.3.073c.558 0 1.206-.7 2.1-2.252a20.9 20.9 0 013.231-.768 5.562 5.562 0 002.355.748 1.1 1.1 0 00.277-.03.471.471 0 00.275-.188 1 1 0 00.11-.673.449.449 0 00-.133-.229zM.546 8.41a3.89 3.89 0 011.1-1.316c.037-.03.13-.117.214-.2A3.958 3.958 0 01.546 8.407zM4.073.288c.179 0 .281.452.29.876a1.794 1.794 0 01-.214.941A4.6 4.6 0 013.998.93s-.007-.642.075-.642zM3.021 6.076c.125-.224.255-.459.388-.71a13.538 13.538 0 00.681-1.485 4.906 4.906 0 001.123 1.395q.083.07.175.141a14.359 14.359 0 00-2.367.659zm5.685-.051a.809.809 0 01-.313.054 3.685 3.685 0 01-1.3-.392c.218-.016.417-.024.6-.024a2.3 2.3 0 01.745.08c.32.082.324.248.269.282z",
    fill: "#bbb",
    strokeWidth: 0.6,
    strokeLinejoin: "round",
    stroke: "#bbb"
  }))))));
}

export default SvgKpmgReportDownloadDisabled;